import primary from "./primary";
import secondary from "./secondary";
import info from "./info";

export const PALETTES = {
  primary,
  secondary,
  info,
};

export default PALETTES;
